import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-3 text-lg" }

interface Props {
  title: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_BaseBox = _resolveComponent("BaseBox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    role: "button",
    class: "block"
  }, {
    default: _withCtx(({ isActive }) => [
      _createVNode(_component_BaseBox, {
        class: _normalizeClass(["hover:bg-opacity-10 hover:bg-black active:bg-opacity-20", { 'bg-black bg-opacity-10': isActive }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default"),
            _createElementVNode("span", null, _toDisplayString(__props.title), 1)
          ])
        ]),
        _: 2
      }, 1032, ["class"])
    ]),
    _: 3
  }))
}
}

})